import * as React from "react";
import { useAuth } from "../components/AuthProvider";

function useWalletAddress() {
  const {
    metaMask: {
      state: { accounts: mmAccounts },
    },
    coinBase: {
      state: { accounts: cbAccounts },
    },
    walletConnect: {
      state: { accounts: wcAccounts },
    },
  } = useAuth();

  return React.useMemo(
    () =>
      ([] as string[]).concat(
        mmAccounts ?? [],
        cbAccounts ?? [],
        wcAccounts ?? []
      )[0],
    [mmAccounts, cbAccounts, wcAccounts]
  );
}

export { useWalletAddress };
